export function loadLocalPreferences<T extends object>(key: string, defaults: T): T {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(key) ?? '{}')
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return defaults
    return { ...defaults, ...parsed }
  } catch {
    return defaults
  }
}

export function saveLocalPreferences(key: string, value: object) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value))
  } catch {
    // Storage can be unavailable in private or locked-down browser contexts.
  }
}
